import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import QuestionsLayer from "../components/QuestionsLayer";

const QuestionsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Manage Questions" />

        {/* QuestionsLayer */}
        <QuestionsLayer />
      </MasterLayout>
    </>
  );
};

export default QuestionsPage;
